import React from 'react';
import { Card, CardContent } from './ui/Card';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/Carousel';
export function TerritoriesSection() {
  const territories = [{
    name: 'Agadir Inezgane',
    description: 'Le cœur battant de la région, capitale touristique du Maroc',
    image: 'https://cdn.magicpatterns.com/uploads/fjbyH9hKS7XuvEmQRzXBw9/1_agadir_inezgane.png'
  }, {
    name: 'Chtouka Aït Baha',
    description: 'Entre mer, plaines agricoles et montagnes',
    image: 'https://cdn.magicpatterns.com/uploads/jG4KHGciro1GvQPM465QKS/2_chtouka_ait_baha.png'
  }, {
    name: 'Taroudant',
    description: 'La petite Marrakech, joyau du Souss',
    image: 'https://cdn.magicpatterns.com/uploads/j4WDtftFhfuN5x7MqGwXj8/3_taroudant.png'
  }, {
    name: 'Tata',
    description: 'Oasis et paysages désertiques grandioses',
    image: 'https://cdn.magicpatterns.com/uploads/1rrVKVEhWzV8rYMuvgNr5B/4_tata.png'
  }, {
    name: 'Tiznit',
    description: "Capitale de l'orfèvrerie et de l'artisanat berbère",
    image: 'https://cdn.magicpatterns.com/uploads/4gr1SXfqkgWQPtjwkHateJ/5_tiznit.png'
  }, {
    name: 'Inezgane Aït Melloul',
    description: 'Centre économique et commercial dynamique',
    image: 'https://cdn.magicpatterns.com/uploads/fjbyH9hKS7XuvEmQRzXBw9/1_agadir_inezgane.png'
  }];
  return <section className="bg-arih-light-bg py-[120px] relative overflow-hidden" data-id="element-229">
      <div className="container mx-auto px-4 md:px-8 relative z-10" data-id="element-230">
        <Carousel opts={{
        align: 'start',
        loop: true
      }} className="w-full" data-id="element-231">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-232">
            <div className="max-w-3xl" data-id="element-233">
              <h2 className="text-[40px] md:text-[64px] font-bold text-arih-dark leading-tight mb-4" data-id="element-234">
                Souss Massa et ses territoires
              </h2>
              <p className="text-[18px] text-arih-gray leading-[28.8px]" data-id="element-235">
                Découvrez les six provinces qui composent la région Souss-Massa,
                chacune avec son identité unique et son patrimoine culturel
                riche.
              </p>
            </div>
            <div className="flex gap-2" data-id="element-236">
              <CarouselPrevious className="relative inset-0 translate-y-0 h-12 w-12 bg-white hover:bg-gray-100 border border-gray-200 text-arih-dark shadow-sm" data-id="element-237" />
              <CarouselNext className="relative inset-0 translate-y-0 h-12 w-12 bg-white hover:bg-gray-100 border border-gray-200 text-arih-dark shadow-sm" data-id="element-238" />
            </div>
          </div>

          <CarouselContent className="-ml-4 md:-ml-6" data-id="element-239">
            {territories.map((item, index) => <CarouselItem key={index} className="pl-4 md:pl-6 md:basis-1/2" data-id="element-240">
                <Card className="border-0 shadow-none bg-transparent group cursor-pointer" data-id="element-241">
                  <CardContent className="p-0" data-id="element-242">
                    <div className="overflow-hidden rounded-xl mb-6" data-id="element-243">
                      <img src={item.image} alt={item.name} className="w-full h-[300px] md:h-[450px] object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-244" />
                    </div>
                    <h3 className="text-[24px] font-bold text-arih-dark mb-2" data-id="element-245">
                      {item.name}
                    </h3>
                    <p className="text-[18px] text-arih-gray" data-id="element-246">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>
      </div>
    </section>;
}